module.exports = __webpack_public_path__ + "img/left-guide-hero.32090662.png";